import { formatHelper } from "helper/format";
import _get from "lodash/get";

const masterParser = {};

masterParser.rmsRiskAssessmentQuestions = (res) => {
    let data = [];

    if (res && res.response) {
        res = res.response;
    }

    if (!res || !res.length) {
        return data;
    }

    const parseOptions = (options) =>
        options.map((o) => ({
            questionId: _get(o, "questionId", null),
            id: _get(o, "optionId", null),
            slug: _get(o, "optionSlug", null),
            name: _get(o, "optionName", null),
        }));

    data = res.map((r) => ({
        id: _get(r, "questionId", null),
        slug: _get(r, "questionSlug", null),
        name: _get(r, "questionName", null),
        options: parseOptions(_get(r, "options", [])),
    }));

    return data;
};

masterParser.rmsRiskProfiles = (res) => {
    let data = [];

    if (res && res.response) {
        res = res.response;
    }

    if (!res || !res.length) {
        return data;
    }

    data = res.map((r) => ({
        id: _get(r, "riskProfileId", null),
        name: _get(r, "riskProfileName", null),
        riskLevelValue: _get(r, "riskProfileValue", null),
        description: _get(r, "riskProfileDescription", null),
        scoreAlert: _get(r, "riskReturnScoreAlert", null),
        scoreMessage: _get(r, "riskReturnScoreMessage", null),
    }));

    return data;
};

masterParser.getMasterBrokers = (res) => {
    if (res && res.response) {
        res = res.response;
    }

    if (res && res.list) {
        res = res.list;
    }

    if (!res || !res.length) {
        return [];
    }

    return res.map(r => ({
        brokerId: _get(r, "brokerId", null),
        brokerName: _get(r, "brokerName", null),
        brokerDisplayName: _get(r, "brokerDisplayName", null),
        brokerPlatform: _get(r, "brokerPlatform", null),
        brokerIcon: formatHelper.getLegacyImageURI(_get(r, "brokerIcon", null)),
        brokerCode: _get(r, "brokerCode", null),
    }))
}

// masterParser.getOnestockMasterBrokers = (res) => {
//     if (res && res.response) {
//         res = res.response;
//     }

//     if (res && res.list) {
//         res = res.list;
//     }

//     if (!res || !res.length) {
//         return [];
//     }

//     return res.map(r => ({
//         brokerId: _get(r, "brokerId", null),
//         brokerName: _get(r, "brokerName", null),
//         brokerDisplayName: _get(r, "brokerDisplayName", null),
//         brokerPlatform: _get(r, "brokerPlatform", null),
//         brokerIcon: formatHelper.getLegacyImageURI(_get(r, "brokerIcon", null)),
//         brokerCode: _get(r, "brokerCode", null),
//     }))
// }

masterParser.validateOffer = (res) => {
    if (res && res.response) {
        res = res.response;
    }

    if (res && res.result) {
        res = res.result;
    }

    if (!res || !Object.keys(res).length) {
        return {};
    }

    return {
        discountType: _get(res, 'discountType', null),
        discountValue: _get(res, 'discountValue', null),
        discountPrice: _get(res, "discountPrice", _get(res, "couponDiscount", null)),
        discountedPrice: _get(res, 'discountedPrice', _get(res, "payableSubcriptionFee", null)),
        isValid: _get(res, 'isValid', null),
        offerCode: _get(res, 'offerCode', null),
        offerId: _get(res, 'offerId', null),
        offerIteration: _get(res, 'offerIteration', null),
        percentageOff: _get(res, 'percentageOff', null),
        yearlysubcription: _get(res, 'yearlysubcription', null),
        couponDiscount: _get(res, 'couponDiscount', null),
    }
}

const PRODUCT_INFO_IMAGE_PAGE = "product_info_page";

const pickProductInfoPageImage = (list) => {
    const items = Array.isArray(list) ? list : [];
    const match = items.find((item) => {
        const url = item?.imageUrl || item?.image_url;
        const pages = item?.page || item?.pages;
        return (
            typeof url === "string" &&
            url.trim() &&
            Array.isArray(pages) &&
            pages.includes(PRODUCT_INFO_IMAGE_PAGE)
        );
    });
    const url = match?.imageUrl || match?.image_url;
    return typeof url === "string" && url.trim() ? url.trim() : null;
};

masterParser.parsePaymentOfferBanner = (res) => {
    if (res && res.response) {
        res = res.response;
    }

    if (res && res.result) {
        res = res.result;
    }

    if (
        res &&
        res.data &&
        typeof res.data === "object" &&
        !Array.isArray(res.data) &&
        (res.data.show !== undefined ||
            res.data.payment ||
            res.data.productInfo ||
            res.data.title)
    ) {
        res = res.data;
    }

    if (!res || !Object.keys(res).length) {
        return null;
    }

    const show = _get(res, "show", false) === true;
    if (!show) {
        return null;
    }

    const payment = _get(res, "payment", null);
    const paymentObj = payment && typeof payment === "object" ? payment : {};
    const productInfoRaw = _get(res, "productInfo", null);
    const productInfoObj =
        productInfoRaw && typeof productInfoRaw === "object" ? productInfoRaw : {};

    const title =
        _get(paymentObj, "title", "") || _get(res, "title", "") || "";
    const description =
        _get(paymentObj, "description", "") || _get(res, "description", "") || "";
    const badgeText =
        _get(paymentObj, "badgeText", "") || _get(res, "badgeText", "") || "";
    const imageMetadata =
        _get(productInfoObj, "image_metadata", null) ||
        _get(productInfoObj, "imageMetadata", null) ||
        {};

    const parseOfferDateMs = (value, { endOfDay } = {}) => {
        if (value == null || value === "") {
            return null;
        }
        if (typeof value === "number") {
            return Number.isFinite(value) ? value : null;
        }
        const raw = String(value).trim();
        const asDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(raw);
        const iso = asDateOnly
            ? `${raw}${endOfDay ? "T23:59:59+05:30" : "T00:00:00+05:30"}`
            : raw;
        const ms = new Date(iso).getTime();
        return Number.isNaN(ms) ? null : ms;
    };

    return {
        show: true,
        title,
        description,
        badgeText,
        startsAt: parseOfferDateMs(
            _get(res, "startDate", _get(res, "StartDate", null)),
            { endOfDay: false },
        ),
        endsAt: parseOfferDateMs(
            _get(res, "endDate", _get(res, "EndDate", null)),
            { endOfDay: true },
        ),
        productInfo: {
            title: _get(productInfoObj, "title", "") || "",
            description: _get(productInfoObj, "description", "") || "",
            badgeText: _get(productInfoObj, "badgeText", "") || "",
            highlightText: _get(productInfoObj, "highlightText", "") || "",
            webImageUrl: pickProductInfoPageImage(
                imageMetadata.web || imageMetadata.Web,
            ),
            mobileImageUrl: pickProductInfoPageImage(
                imageMetadata.mobile || imageMetadata.Mobile,
            ),
        },
    };
}

masterParser.pendingCall = (res) => {
    if (res && res.response) {
        res = res.response;
    }

    if (res && res.result) {
        res = res.result;
    }

    if (!res || !Object.keys(res).length) {
        return {};
    }

    let count = 0
    let portfolioPendingCount = 0
    let protectPendingCount = 0
    let onestockPendingCount = 0
    let primePendingCount = 0
    let sentimentPendingCount = 0

    if (res.isMobileVerified === 0) {
        count = count + 1
    }

    if (res.isEmailVerified === 0) {
        count = count + 1
    }

    if (res.PORTFOLIO.isPendingCall === 1) {
        portfolioPendingCount = portfolioPendingCount + 1
    }
    
    if (res.PORTFOLIO.isPlanExpired === 1) {
        portfolioPendingCount = portfolioPendingCount + 1
    }

    if (res.RMS.isPendingCall === 1) {
        protectPendingCount = protectPendingCount + 1
    }
    
    if (res.RMS.isPlanExpired === 1) {
        protectPendingCount = protectPendingCount + 1
    }

    if (res.ONESTOCK.isPendingCall === 1) {
        onestockPendingCount = onestockPendingCount + 1
    }
    
    if (res.ONESTOCK.isPlanExpired === 1) {
        onestockPendingCount = onestockPendingCount + 1
    }

    if (res.PRIME.isPendingCall === 1) {
        primePendingCount = primePendingCount + 1
    }
    
     if (res.PRIME.isPlanExpired === 1) {
        primePendingCount = primePendingCount + 1
    }

    if (res.SENTIMENT.isPlanExpired === 1) {
        sentimentPendingCount = sentimentPendingCount + 1
    }

    let totalPendingCount = count + portfolioPendingCount + protectPendingCount + onestockPendingCount + primePendingCount + sentimentPendingCount

    return {
        isMobileVerified: _get(res, 'isMobileVerified', null),
        isEmailVerified: _get(res, 'isEmailVerified', null),
        portfolioData: _get(res, "PORTFOLIO", {}),
        protectData: _get(res, 'RMS', {}),
        onestockData: _get(res, 'ONESTOCK', {}),
        portfolioPendingCallType: _get(res, "PORTFOLIO.pendingCallType", null).replace("_"," ").toLowerCase(),
        protectPendingCallType: _get(res, "RMS.pendingCallType", null).replace("_"," ").toLowerCase(),
        onestockPendingCallType: _get(res, "ONESTOCK.pendingCallType", null).replace("_"," ").toLowerCase(),
        sentimentPendingCallType: _get(res, "SENTIMENT.pendingCallType", null).replace("_"," ").toLowerCase(),
        totalPendingCount: totalPendingCount,
        portfolioPendingCount: portfolioPendingCount,
        protectPendingCount: protectPendingCount,
        onestockPendingCount: onestockPendingCount,
        mandatoryCount: count,
        primeData: _get(res, "PRIME", {}),
        primePendingCallType: _get(res, "PRIME.pendingCallType", null).replace("_"," ").toLowerCase(), 
        primePendingCount : primePendingCount, 
        sentimentData: _get(res, "SENTIMENT", {}),
        sentimentPendingCallType: _get(res, "SENTIMENT.pendingCallType", null).replace("_"," ").toLowerCase(), 
        sentimentPendingCount : sentimentPendingCount,   
        phcData :  _get(res, "PHC", {}),
    }
}

masterParser.fetchPlanDiscountedPriceOnUpgrade = (res)=>{
    if (res && res.response) {
        res = res.response;
    }

    if (res && res.result) {
        res = res.result;
    }

    if (!res || !Object.keys(res).length) {
        return {};
    }
    return res;
}
export { masterParser };
